const Button = ({ onClick, text, extraClasses, cancel, disabled }) => (
	<button
		className={`${
			cancel ? "border border-gray-300 bg-white" : "background-theme text-theme"
		} rounded p-2 font-semibold ${disabled ? "opacity-50" : ""} ${extraClasses}`}
		onClick={onClick}
		disabled={disabled}
	>
		{text}
	</button>
);

export default Button;
